import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import classNames from 'classnames';

import { useMediaQuery } from '@material-ui/core';
import { DateRangePicker } from 'react-dates';

import { Button, Typography } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import DateRangeIcon from '@material-ui/icons/DateRange';

import { LOCALES_OBJ } from 'constants/base';

import { useStyles } from './styles';
import { getIsHalf } from '../../utils/book-accommodation/getIsHalf';

const MultiDatePickerCalendar = ({
  isStartDateRenderMonth,
  isOutsideRange,
  inputClassName,
  input,
  label,
  className,
  secondLabelClass,
  availableRange,
  disabledDates,
  changeMonthsCallback,
  dateRangePickerClass,
  isInput,
  numberOfMonths,
  isHideDatesLabel,
  labelTypographyVariant,
  cutoffData,
  daySize,
  initialFocus,
  meta: { touched, error, submitFailed }
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  const [focus, setFocus] = React.useState(initialFocus || null);
  const [isHiddenNextButton, setHiddenNextButton] = React.useState(false);

  const [render, setRender] = React.useState(true);

  const [renderMonth, setRenderMonth] = React.useState(
    isStartDateRenderMonth && input.value.startDate
      ? input.value.startDate
      : moment()
  );

  React.useEffect(() => {
    setRender(!render);
    setTimeout(() => {
      setRender(render);
    });
  }, [selectedLanguage]);

  // const selectedStartDate = input.value.startDate;

  // const onChangeHandler = (startDate, endDate) => {
  //   if (!moment(startDate).isSame(selectedStartDate, 'day')) {
  //     input.onChange({ startDate, endDate: null });
  //     return;
  //   }

  //   input.onChange({ startDate, endDate });
  // };
  const onChangeHandler = (startDate, endDate) => {
    if (!endDate || moment(startDate).isSame(endDate, 'day')) {
        input.onChange({ startDate, endDate: startDate });
        return;
    }

    const dateRange = getDates(startDate, endDate); 
    const isAnyBlocked = dateRange.some(date => isBlockedDay(date));

    if (isAnyBlocked) {
        input.onChange({ startDate, endDate: startDate });
    } else {
        // Allow range selection if no dates in range are blocked
        input.onChange({ startDate, endDate });
    }
};

  const onPrevMonthClickHandler = date => {
    setRenderMonth(date);
    setHiddenNextButton(false);
    if (changeMonthsCallback) changeMonthsCallback(date);
  };

  const onNextMonthClickHandler = date => {
    setRenderMonth(date);
    const currentDate = moment();
    const endAvailableDate = moment(currentDate).add(23, 'M');

    const isTheSameDates = moment(date)
      .startOf('month')
      .isSame(endAvailableDate.startOf('month'));

    if (isTheSameDates) setHiddenNextButton(true);
    if (changeMonthsCallback) changeMonthsCallback(date);
  };
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isBlockDayByCutoffPeriodWithoutTime = (
    cutoffPeriod,
    cutoffPeriodTimeType,
    isDayBlocked,
    date
  ) => {
    if (!cutoffPeriod) return isDayBlocked;

    const dateWithTime = moment(date).set({
      hour: 0,
      minute: 0
    });
    const nowCutoffDate = moment().add(cutoffPeriod, cutoffPeriodTimeType);

    if (moment(dateWithTime).isSameOrBefore(nowCutoffDate, 'day')) {
      return true;
    }

    return false;
  };

  const isBlockDayByCutoffPeriodWithTime = (
    cutoffPeriod,
    cutoffPeriodTimeType,
    startTimeAndDuration,
    date
  ) => {
    const disabledStartTimeList = startTimeAndDuration.map(item => {
      const startTime = moment(item.startTime, 'HH:mm');
      const dateWithTime = moment(date).set({
        hour: startTime.get('hour'),
        minute: startTime.get('minute')
      });
      const nowCutoffDate = moment().add(cutoffPeriod, cutoffPeriodTimeType);
      const difference = moment(dateWithTime).diff(nowCutoffDate);
      return difference <= 0;
    });

    if (disabledStartTimeList.every(value => value)) {
      return true;
    }

    return false;
  };

  function getDates(startDate, stopDate) {
    const dateArray = [];
    let currentDate = moment(startDate);
    let endDate = moment(stopDate);
    while (currentDate <= endDate) {
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  const isBlockDayByCutoffPeriod = (date, isDayBlocked) => {
    if (isDayBlocked) return isDayBlocked;

    if (cutoffData) {
      const days = cutoffData.days;
      const daysArray = cutoffData.daysArray;

      const cutoffPeriod = parseInt(cutoffData.cutoffPeriod);
      const cutoffPeriodTimeType = cutoffData.cutoffPeriodTimeType;

      if (days) {
        const isDisabled = isBlockDayByCutoffPeriodWithoutTime(
          cutoffPeriod,
          cutoffPeriodTimeType,
          isDayBlocked,
          date
        );
        if (isDisabled) return true;
      } else if (daysArray) {
        let isDisabledDate = false;

        daysArray.map(item => {
          const days = item.days;
          const startTimeAndDuration = item.startTimeAndDuration;

          const dateDay = moment(date).format('ddd');

          if (days[dateDay]) {
            if (startTimeAndDuration.length) {
              const isDisabled = isBlockDayByCutoffPeriodWithTime(
                cutoffPeriod,
                cutoffPeriodTimeType,
                startTimeAndDuration,
                date
              );
              if (isDisabled) isDisabledDate = true;
            } else {
              const isDisabled = isBlockDayByCutoffPeriodWithoutTime(
                cutoffPeriod,
                cutoffPeriodTimeType,
                isDayBlocked,
                date
              );
              if (isDisabled) isDisabledDate = true;
            }
          }
        });

        if (isDisabledDate) return true;
      }
    }

    return isDayBlocked;
  };

  const isBlockedDay = date => {
    if (
      disabledDates &&
      disabledDates.includes(moment(date).format('YYYY-MM-DD'))
    ) {
      return true;
    }

    if (input.value.startDate && !input.value.endDate) {
      const arr = getDates(input.value.startDate, date);
      let flag = false;

      arr.forEach((el, item) => {
        const dayOfWeek = moment(el).format('ddd');
        if (
          !!availableRange &&
          !availableRange?.daysOfWeek.includes(dayOfWeek)
        ) {
          flag = true;
        }
      });

      disabledDates.forEach(el => {
        if (moment(el).isBetween(input.value.startDate, date, 'day', '[]')) {
          flag = true;
        }
      });

      if (flag) {
        return true;
      }
    }

    if (!availableRange) return false;

    if (availableRange.endDate && availableRange.endDate !== 'None') {
      const isBetween = moment(date).isBetween(
        availableRange.startDate,
        availableRange.endDate,
        'day',
        '[]'
      );

      if (isBetween) {
        const dayOfDate = moment(date).format('ddd');
        return !availableRange.daysOfWeek.includes(dayOfDate);
      }
    } else {
      const isSameOrAfter = moment(date).isSameOrAfter(
        availableRange.startDate,
        'day'
      );

      if (isSameOrAfter) {
        const dayOfDate = moment(date).format('ddd');
        return !availableRange.daysOfWeek.includes(dayOfDate);
      }
    }

    return true;
  };

  const handleResetDate = () => {
    onChangeHandler(null, null);
    setFocus(initialFocus || null);
  };

  return (
    <div className={classes.container}>
      <div
        className={classNames(
          classes.wrapper,
          className,
          initialFocus ? classes.wrapperInitialFocus : ''
        )}
      >
        {initialFocus ? (
          <label className={classNames(classes.secondLabel, secondLabelClass)}>
            <Typography
              variant={labelTypographyVariant ? labelTypographyVariant : 'h2'}
            >
              {t(label)}
            </Typography>
            <div className={classes.datesLabel}>
              <Typography variant="body1" className={classes.fromTo}>
                {input.value && !isHideDatesLabel ? `${t('From – To')}:` : ' '}
              </Typography>
              <Typography variant="body1">
                {input.value && (
                  <>
                    {input.value.startDate &&
                      moment(input.value.startDate)
                        .locale(LOCALES_OBJ[selectedLanguage])
                        .format('MMM D, YYYY')}{' '}
                    –{' '}
                    {input.value.endDate &&
                      moment(input.value.endDate)
                        .locale(LOCALES_OBJ[selectedLanguage])
                        .format('MMM D, YYYY')}
                  </>
                )}
              </Typography>
            </div>
          </label>
        ) : (
          <label htmlFor="startDate" className={classes.label}>
            {t(label)}
          </label>
        )}

        <label
          htmlFor="startDate"
          onClick={() => setFocus('startDate')}
          className={classNames(
            classes.customInputDate,
            {
              [classes.focus]: focus
            },
            {
              [classes.errorInput]: (touched || submitFailed) && error
            },
            inputClassName
          )}
        >
          <DateRangeIcon className={classes.calendarIcon} />

          {input.value.startDate ? (
            moment(input.value.startDate)
              .locale(LOCALES_OBJ[selectedLanguage])
              .format('MMM D, YYYY')
          ) : (
            <div>{t('Start date')}</div>
          )}
          <span className={classes.dateRangeDivider}>-</span>
          {input.value.endDate ? (
            moment(input.value.endDate)
              .locale(LOCALES_OBJ[selectedLanguage])
              .format('MMM D, YYYY')
          ) : (
            <div>{t('End date')}</div>
          )}
        </label>

        {!initialFocus && (touched || submitFailed) && error && (
          <FormHelperText className={classes.error} error>
            {t(error)}
          </FormHelperText>
        )}

        <div
          className={classNames(
            classes.hiddenDateRangePicker,
            dateRangePickerClass
          )}
        >
          {render && (
            <DateRangePicker
              verticalSpacing={0}
              readOnly={true}
              noBorder={true}
              customArrowIcon={<div>{''}</div>}
              startDateId="startDate"
              endDateId="endDate"
              displayFormat="MMM D, YYYY"
              startDate={input.value.startDate}
              endDate={input.value.endDate}
              onDatesChange={({ startDate, endDate }) => {
                onChangeHandler(startDate, endDate);
              }}
              minimumNights={0}
              onPrevMonthClick={onPrevMonthClickHandler}
              onNextMonthClick={onNextMonthClickHandler}
              navNext={isHiddenNextButton ? <div>{''}</div> : ''}
              initialVisibleMonth={() => renderMonth}
              isOutsideRange={isOutsideRange}
              focusedInput={focus}
              onFocusChange={focusedInput => {
                setFocus(focusedInput || initialFocus || null);
              }}
              isDayBlocked={date => {
                const isBlocked = isBlockedDay(date);
                return isBlockDayByCutoffPeriod(date, isBlocked);
              }}
              daySize={daySize ? daySize : 38}
              numberOfMonths={numberOfMonths ? numberOfMonths : 2}
              // numberOfMonths={isSmallScreen ? 1 : 2}
              // daySize={isSmallScreen ? 30 : 38}
              renderMonthElement={({ month }) =>
                moment(month)
                  .locale(LOCALES_OBJ[selectedLanguage])
                  .format('MMMM YYYY')
              }
              renderDayContents={day => {
                if (selectedLanguage === 'Norway') {
                  day._locale._weekdaysMin = [
                    'Sø',
                    'Ma',
                    'Ti',
                    'On',
                    'To',
                    'Fr',
                    'Lø'
                  ];
                } else {
                  day._locale._weekdaysMin = [
                    'Su',
                    'Mo',
                    'Tu',
                    'We',
                    'Th',
                    'Fr',
                    'Sa'
                  ];
                }

                const { disableLeft, disableRight } = getIsHalf(
                  disabledDates,
                  day
                );

                return (
                  <div
                    className={classNames({
                      [classes.dayHalfAvailable]: disableLeft || disableRight,
                      [classes.dayLeftDisable]: disableLeft,
                      [classes.dayRightDisable]: disableRight
                    })}
                  >
                    <div>{day.format('D')}</div>
                  </div>
                );
              }}
              hideKeyboardShortcutsPanel={true}
            />
          )}
          {initialFocus && input.value.startDate && (
            <Button
              className={classes.ClearButton}
              onClick={() => {
                handleResetDate();
              }}
            >
              Clear date
            </Button>
          )}
        </div>

        {initialFocus && (touched || submitFailed) && error && (
          <FormHelperText
            className={classNames({ [classes.error]: isInput })}
            error
          >
            {t(error)}
          </FormHelperText>
        )}
      </div>
    </div>
  );
};

export default MultiDatePickerCalendar;
